<template>
    <div :data-cy="`HighlightTypeItem-${type_id}-button`"
        :class="
            'd-flex flex-column justify-center align-center pa-3 border-radius-1 h-type elevation-4 transition-all ' +
            (active ? 'active' : '')
        "
        :id="`h-type-${type_id}`"
        @click="setSelectedType"
    >
        <img :src="img" alt="icono de marcador" />
        <span class="font-size-14">{{ value }}</span>
    </div>
</template>
<script>
export default {
    props: {
        type_id: { type: [Number, String], default: null },
        img: { type: String, default: null },
        value: { type: String, default: null },
        active: { type: Boolean, default: null },
    },
    methods: {
        setSelectedType() {
            this.$emit('select')
        },
    },
}
</script>
